
























import Vue from 'vue'
import { ExecutionDto, HeavyTicketsDto, HeavyTicketDto } from '@/Application/Expediente'
import ExecutionForm from '@/UI/UserProcedures/WonProcedures/WonProcedureDetailTabs/Execution/ExecutionForm.vue'
import HeavyTicketsView from '@/UI/UserProcedures/WonProcedures/WonProcedureDetailTabs/Execution/HeavyTicketsView.vue'
import { OfferTarget } from '@/Domain/Offer'
import { Currency } from '@/Domain/Batch/Currency'
import { NewDate } from '@/Domain/News'

interface gruoped {
  groupedHeavyTickets: HeavyTicketsDto
}

export default Vue.extend({
  name: 'Execution',
  components: { ExecutionForm, HeavyTicketsView },
  props: {
    execution: {
      type: ExecutionDto || null,
      required: false
    }
  },
  data (): gruoped {
    return {
      groupedHeavyTickets: new HeavyTicketsDto([], 0)
    }
  },
  computed: {
    hasTickets (): boolean {
      return this.execution && this.execution.getHeavyTickets().tickets.length > 0
    }
  },
  mounted () {
    this.groupedHeavyTickets = this.groupingHeavyTickets()
  },
  methods: {
    groupingHeavyTickets (): HeavyTicketsDto {
      let gruopedHeavyTickets = new HeavyTicketsDto([], 0)
      if (this.execution != null) {
        const heavyTickets = this.execution.getHeavyTickets()
        gruopedHeavyTickets = new HeavyTicketsDto([], heavyTickets.total)
        const speciesChecked: string[] = []
        heavyTickets.tickets.forEach(ticket => {
          const checkSpecie = speciesChecked.filter(spec => spec === ticket.especie)
          if (checkSpecie.length === 0) {
            speciesChecked.push(ticket.especie)
            const serra1 = heavyTickets.tickets.filter(tick => tick.destinoMadeira === OfferTarget.SERRA1 && tick.especie === ticket.especie)
            if (serra1.length > 0) {
              const ticketSerra1 = this.getHeavyTicket(serra1, OfferTarget.SERRA1)
              gruopedHeavyTickets.addTicket(ticketSerra1)
            }
            const serra2 = heavyTickets.tickets.filter(tick => tick.destinoMadeira === OfferTarget.SERRA2 && tick.especie === ticket.especie)
            if (serra2.length > 0) {
              const ticketSerra2 = this.getHeavyTicket(serra2, OfferTarget.SERRA2)
              gruopedHeavyTickets.addTicket(ticketSerra2)
            }
            const trituracion = heavyTickets.tickets.filter(tick => tick.destinoMadeira === OfferTarget.TRITURACION && tick.especie === ticket.especie)
            if (trituracion.length > 0) {
              const ticketTrituracion = this.getHeavyTicket(trituracion, OfferTarget.TRITURACION)
              gruopedHeavyTickets.addTicket(ticketTrituracion)
            }
          }
        })
      }
      return gruopedHeavyTickets
    },
    getWeight (tickets: HeavyTicketDto[]): Currency {
      let peso = new Currency(0)
      tickets.forEach(ticket => {
        peso = peso.add(ticket.peso)
      })

      return peso
    },
    getTotalCost (tickets: HeavyTicketDto[]): Currency {
      let total = new Currency(0)
      tickets.forEach(ticket => {
        total = total.add(ticket.custoTotalTicket)
      })

      return total
    },
    getHeavyTicket (tickets: HeavyTicketDto[], destino: OfferTarget): HeavyTicketDto {
      const peso = this.getWeight(tickets)
      const total = this.getTotalCost(tickets)
      const ticket = new HeavyTicketDto(tickets[0].especie, tickets[0].forma, destino, tickets[0].numMatricula, new NewDate(tickets[0].dataPesada), peso, total)
      return ticket
    }
  }
})
